export default "__VITE_ASSET__057cdb06__$_?react__"